import {fetchDelete, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const updateOrganization = async({token, organization}) => {
  const url = `${generateEndpoint("updateOrganization")}`;
  return fetchPatch(url, token, {organization});
};

export const createOrganization = async({token, organization}) => {
  const url = `${generateEndpoint("createOrganization")}`;
  return fetchPost(url, token, {organization});
};

export const deleteOrganization = async({token, id}) => {
  const url = `${generateEndpoint("deleteOrganization")}`;
  return fetchDelete(url, token, {id});
};
